// React
import { useEffect, useState } from "react"

// Types
import type { SelectOptionType, SuccessFetch } from "types"

// Utils
import { useApi } from "utils"

export interface SelectTypeSchedule extends SelectOptionType {
  periode_start: string
  periode_end: string
  trx_code: string
  approve_status?: string
}

export function useListDropdownSchedule({ approve_status } : {approve_status?: string}) {

  // Hooks
  const api = useApi()
  const [data, setData] = useState<SelectTypeSchedule[]>([])
  const [isLoading, setLoading] = useState(true)

  const params: { [key: string]: number | string | undefined } = {};
  if (approve_status) params.approve_status = approve_status;

  function refetch() {
    setLoading(true)

    api.get("/employee/list_data_schedule", { params }).then((res: SuccessFetch<{
      payload: {
        trx_code: string
        periode_start: string
        periode_end: string
        shift_schedule_id: number
        approve_status: string
      }[]
    }>) => {
      setData(res.data.payload.map(item => {
        return {
          label: `${item.trx_code} ( ${item.periode_start} - ${item.periode_end} )`,
          value: item.shift_schedule_id.toString(),
          periode_start: item.periode_start,
          periode_end: item.periode_end,
          trx_code: item.trx_code,
          approve_status: item.approve_status
        }
      }))
    }).catch(() => {
      setData([])
    }).finally(() => {
      setLoading(false)
    })
  }

  useEffect(() => {
    refetch()
  
    return () => {
      setData([])
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [ approve_status ])

  

  return { data, isLoading, refetch }
}